// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delivery-list__link{display:inline-block;margin-top:16px;font-weight:500;font-size:14px;line-height:24px;color:var(--hxrk7)}.delivery-list__link:hover{text-decoration:underline}.delivery-list__empty{display:flex;align-items:center;justify-content:center;height:88px;font-size:14px;line-height:22px}", ""]);
// Exports
module.exports = exports;
